export const getSku = '/sku';
export const getSkuDetail = '/sku/';
export const addSku = '/sku/addSku';
export const updateSku = '/sku/';
export const deleteSku = '/sku/';
export const updateSkuStatus = '/sku/update-status/';
